const getNestedPropertySafe = (nestedObj, pathArr) => {
  return pathArr.reduce(
    (obj, key) => (obj && obj[key] !== "undefined" ? obj[key] : undefined),
    nestedObj
  );
};

export const ObjectTools = {
  getNestedPropertySafe,
};
